module.exports = __webpack_public_path__ + "static/img/mp3_play.f488eb9b.png";